import React from "react";
import "./Sidebar.css";

import { obterDadosUsuario2, obterPerfilUsuario } from "../../services/cookies";
import { isMasterUser } from "../../constants/authorization";
import SidebarImage from "../../assets/img/OMEX_white.png";
import { ItensCliente, ItensFuncionario, ItensGestor } from "./ItensSideBar";

import { FiShield, FiX } from "react-icons/fi";
import { CardSidebar, CardSidebarProps } from "../Cards/CardSidebar";

interface SidebarProps {
  sidebar: boolean;
  showSidebar: () => void;
}

const CADASTRO_APPROVAL_PATH = "/gerenciar/cadastro";

const filterMasterOnlyItems = (
  items: CardSidebarProps[],
  hasMasterAccess: boolean
): CardSidebarProps[] =>
  items.flatMap((item) => {
    if (!hasMasterAccess && item.path === CADASTRO_APPROVAL_PATH) {
      return [];
    }

    return [{
      ...item,
      itens: item.itens
        ? filterMasterOnlyItems(item.itens, hasMasterAccess)
        : undefined,
      subItens: item.subItens
        ? filterMasterOnlyItems(item.subItens, hasMasterAccess)
        : undefined,
    }];
  });

const getSidebarItems = (
  perfil: string | null,
  hasMasterAccess: boolean
): CardSidebarProps[] => {
  let items: CardSidebarProps[] = [];

  if (perfil === "Administrador") items = ItensGestor;
  if (perfil === "Funcionario") items = ItensFuncionario;
  if (perfil === "UsuarioAssessoria" || perfil === "UsuarioCustodia") items = ItensCliente;

  return filterMasterOnlyItems(items, hasMasterAccess);
};

const getProfileLabel = (perfil: string | null) => {
  if (perfil === "Administrador") return "Gestão institucional";
  if (perfil === "Funcionario") return "Operações Omex";
  if (perfil === "UsuarioCustodia") return "Cliente custódia";
  if (perfil === "UsuarioAssessoria") return "Cliente assessoria";

  return "Ambiente Omex";
};

const SideBar = ({ sidebar, showSidebar }: SidebarProps) => {
  const perfil = obterPerfilUsuario();
  const hasMasterAccess =
    perfil === "Administrador" && isMasterUser(obterDadosUsuario2().email);
  const sidebarItems = getSidebarItems(perfil, hasMasterAccess);

  return (
    <>
      <button
        className={`app-sidebar-backdrop ${sidebar ? "active" : ""}`}
        type="button"
        aria-label="Fechar menu"
        aria-hidden={!sidebar}
        tabIndex={sidebar ? 0 : -1}
        onClick={showSidebar}
      />
      <nav
        className={`app-sidebar nav-menu ${sidebar ? "active" : ""}`}
        aria-label="Navegação principal"
        aria-hidden={!sidebar}
      >
        <div className="app-sidebar-header">
          <div className="app-sidebar-brand">
            <img src={SidebarImage} className="app-sidebar-logo" alt="Omex Capital" />
            <div>
              <span>{getProfileLabel(perfil)}</span>
            </div>
          </div>
          <button
            className="app-sidebar-close"
            type="button"
            aria-label="Fechar menu"
            onClick={showSidebar}
          >
            <FiX />
          </button>
        </div>

        <div className="app-sidebar-status">
          <FiShield aria-hidden="true" />
          <div>
            <span>Acesso seguro</span>
            <strong>Ambiente autenticado</strong>
          </div>
        </div>

        <ul className="app-sidebar-nav nav-menu-itens">
          {sidebarItems.map((item) => (
            <CardSidebar
              key={`${item.title}-${item.path || "group"}`}
              title={item.title}
              itens={item.itens}
              path={item.path}
              onNavigate={showSidebar}
            />
          ))}
        </ul>

        <div className="app-sidebar-footer">
          <span>OMEX</span>
          <p>Capital digital, tecnologia e operações em um só painel.</p>
        </div>
      </nav>
    </>
  );
};

export default SideBar;
